<template>
  <div>
    <div class="o-form__row o-form__row--center o-form__row--header">
      <h1 class="o-typography__headline5 o-modal__title o-modal__title--center">
        <div v-dompurify-html="header"></div>
      </h1>
    </div>
    <div class="o-popup__row">
      <div class="o-popup__container">
        <i class="o-popup__icon o-icon o-icon--like"></i>
      </div>
    </div>
    <div class="o-popup__row o-popup__row--column o-popup__row--center">
      <p
        v-if="additionalInfo"
        v-dompurify-html="additionalInfo"
        class="o-popup__text o-popup__text--small o-popup__text--center u-mb-30"
      ></p>
      <p
        v-dompurify-html="text"
        class="o-popup__text o-popup__text--small o-popup__text--center"
      ></p>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      additionalInfo: {
        type: String,
        default: '',
      },
      header: {
        type: String,
        required: true,
      },
      text: {
        type: String,
        required: true,
      },
    },
  };
</script>
